import { render, staticRenderFns } from "./DefaultButton.vue?vue&type=template&id=014391f6&scoped=true"
import script from "./DefaultButton.vue?vue&type=script&lang=js"
export * from "./DefaultButton.vue?vue&type=script&lang=js"
import style0 from "./DefaultButton.vue?vue&type=style&index=0&id=014391f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014391f6",
  null
  
)

export default component.exports